import { AxiosInstance } from 'axios';
import {
  ServiceResponse,
  ServicesResponse,
} from 'data/terra/api/terra/response/ServiceResponse';
import { ServiceVersionConfigsResponse } from 'data/terra/api/terra/response/ServiceVersionConfigResponse';
import {
  ServiceVersionResponse,
  ServiceVersionsResponse,
} from 'data/terra/api/terra/response/ServiceVersionResponse';
import { ServiceDescription } from 'data/terra/Service';
import {
  CreateServiceVersionConfigRequest,
  ServiceConfigDescription,
} from 'data/terra/ServiceConfig';
import { CreateServiceVersionRequest } from 'data/terra/ServiceVersion';
import { result, Result } from 'util/result';
import Terra from '../Terra';
class ServiceEndpoint {
  getServicesUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/services`;
  getServiceDetailUrl = (serviceId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/services/${serviceId}`;
  getServiceVersionsUrl = (serviceId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/services/${serviceId}/versions`;
  getServiceVersionConfigsUrl = (serviceId: string, versionId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/services/${serviceId}/versions/${versionId}/configs`;
  getServiceVersionConfigDetailUrl = (
    serviceId: string,
    versionId: string,
    configId: string
  ) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/services/${serviceId}/versions/${versionId}/configs/${configId}`;
}
export class ServiceApi {
  terraClient: AxiosInstance;
  endpoint = new ServiceEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchServices(): Promise<Result<ServicesResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<ServicesResponse>(
            this.endpoint.getServicesUrl(),
            {
              params: {
                pageSize: 200,
              },
            }
          )
        ).data
    );
  }

  addService(data: ServiceDescription): Promise<Result<ServiceResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<ServiceResponse>(
            this.endpoint.getServicesUrl(),
            data
          )
        ).data
    );
  }

  fetchServiceVersions(
    serviceId: string
  ): Promise<Result<ServiceVersionsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<ServiceVersionsResponse>(
            this.endpoint.getServiceVersionsUrl(serviceId),
            {
              params: {
                pageSize: 200,
              },
            }
          )
        ).data
    );
  }

  addServiceVersion(
    serviceId: string,
    data: CreateServiceVersionRequest
  ): Promise<Result<ServiceVersionResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<ServiceVersionResponse>(
            this.endpoint.getServiceVersionsUrl(serviceId),
            data
          )
        ).data
    );
  }

  fetchServiceVersionConfigs(
    serviceId: string,
    versionId: string
  ): Promise<Result<ServiceVersionConfigsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<ServiceVersionConfigsResponse>(
            this.endpoint.getServiceVersionConfigsUrl(serviceId, versionId),
            {
              params: {
                pageSize: 200,
              },
            }
          )
        ).data
    );
  }

  addServiceVersionConfig(
    serviceId: string,
    versionId: string,
    request: CreateServiceVersionConfigRequest
  ): Promise<Result<ServiceVersionConfigsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<ServiceVersionConfigsResponse>(
            this.endpoint.getServiceVersionConfigsUrl(serviceId, versionId),
            request
          )
        ).data
    );
  }

  updateServiceVersionConfig(
    serviceId: string,
    versionId: string,
    configId: string,
    data: ServiceConfigDescription<any>
  ): Promise<Result<ServiceVersionConfigsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.put<ServiceVersionConfigsResponse>(
            this.endpoint.getServiceVersionConfigDetailUrl(
              serviceId,
              versionId,
              configId
            ),
            data
          )
        ).data
    );
  }
}
